import { useState, type ReactNode } from 'react';
import type { TenantConfig } from '@/theme/tenant';
import { useT } from '@/i18n/runtime';
import { BrandMark } from './BrandMark';
import { SecurePill } from './SecurePill';

/** Compact tenant lockup + trust pill (forked from vCIP_droom_4.0/src/flow/components/AppBar.tsx). */
export function AppBar({ tenant, subtitle, right }: { tenant: TenantConfig; subtitle?: string; right?: ReactNode }): JSX.Element {
  const { t } = useT();
  const [needsName, setNeedsName] = useState(() => !tenant.branding.logoUrl);
  return (
    <div className="appbar">
      <div className="lockup">
        <BrandMark tenant={tenant} onNeedsName={setNeedsName} />
        <div>
          {needsName && tenant.name ? (
            <div className="brand-name" style={{ fontSize: 'var(--fs-cap)' }}>
              {tenant.name}
            </div>
          ) : null}
          {subtitle ? <div className="brand-sub">{subtitle}</div> : null}
        </div>
      </div>
      {right ?? <SecurePill label={t('sv.pill.secure')} />}
    </div>
  );
}
